module.exports = __webpack_public_path__ + "img/ppd_logo.f431f949.png";